import { render, staticRenderFns } from "./feeds.vue?vue&type=template&id=3a33a78e&scoped=true&lang=pug&"
import script from "./feeds.vue?vue&type=script&lang=js&"
export * from "./feeds.vue?vue&type=script&lang=js&"
import style0 from "./feeds.vue?vue&type=style&index=0&id=3a33a78e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33a78e",
  null
  
)

export default component.exports